import { Feature } from "../types/features";
import { ConfigElements } from "../constants/common";
import {
    BrandingConfiguration,
    CustomerConfigElement,
    EnvInfo,
    PortalConfig,
    PortalSettings,
    ToolbarConfiguration,
} from "../types/configuration";
import log from "../logging";

export const getPortalConfig = (): PortalConfig => {
    const customerConfigElement = document.getElementById(
        ConfigElements.CUSTOMER_CONFIG
    );
    if (customerConfigElement) {
        const rawConfig = JSON.parse(
            customerConfigElement.innerHTML
        ) as CustomerConfigElement;

        return {
            portalArn: rawConfig.portalArn,
            isFipsEnabled: rawConfig.isFipsEnabled,
            portalCustomDomain: rawConfig.portalCustomDomain,
            customerDomain: rawConfig.customerDomain,
        };
    } else {
        log.warn(
            "Getting Portal config for local development, can safely ignore if WebApp running locally."
        );
        return {
            portalArn: "",
            isFipsEnabled: false,
            portalCustomDomain: null,
            customerDomain: "",
        };
    }
};
export const getEnvInfo = (): EnvInfo => {
    const environmentConfigElement = document.getElementById(
        ConfigElements.ENV_INFO
    );

    if (!environmentConfigElement) {
        throw new Error("env-info element not found in HTML");
    }

    const environmentConfig = JSON.parse(environmentConfigElement.innerHTML);
    const { stage, region, loggerEndpoint = null } = environmentConfig;

    return { stage, region, loggerEndpoint };
};
export const isLocalhost = (): boolean => {
    return window.location.hostname === "localhost";
};
export const getPortalEndpoint = (): string => {
    const { stage } = getEnvInfo();
    const { portalArn, isFipsEnabled, portalCustomDomain } = getPortalConfig();

    // if portal is being accessed using custom domain
    // we will use portal custom domain as portal endpoint
    if (
        portalCustomDomain !== null &&
        window.location.hostname === portalCustomDomain
    ) {
        return `https://${portalCustomDomain}`;
    }

    const arnParts = portalArn.split(":");
    const portalId = arnParts.slice(-1).pop()!.split("/").slice(-1).pop();
    const stageSubdomain = stage.toLowerCase() === "prod" ? "" : `.${stage}`;
    const fips = isFipsEnabled ? "-fips" : "";

    return `https://${portalId}${stageSubdomain}.workspaces-web${fips}.com`;
};
export const isFeatureEnabled = (feature: Feature): boolean => {
    const featuresElement = document.getElementById(ConfigElements.FEATURES);

    if (featuresElement) {
        const features = JSON.parse(featuresElement.innerHTML) as string[];
        return features?.includes(feature);
    }
    return false;
};
export const getToolbarConfig = (): ToolbarConfiguration => {
    const settingsElement = document.getElementById(ConfigElements.SETTINGS);
    if (settingsElement) {
        const settings = JSON.parse(
            settingsElement.innerHTML
        ) as PortalSettings;
        const toolbarConfiguration = settings?.toolbarConfiguration as ToolbarConfiguration;
        return {
            toolbarType: toolbarConfiguration?.toolbarType || undefined,
            hiddenToolbarItems: toolbarConfiguration?.hiddenToolbarItems || [],
            maxDisplayResolution:
                toolbarConfiguration?.maxDisplayResolution || "",
            visualMode:
                toolbarConfiguration?.visualMode?.toLowerCase() || undefined,
        };
    }

    return {
        toolbarType: undefined,
        hiddenToolbarItems: [],
        maxDisplayResolution: "",
        visualMode: undefined,
    };
};
export const getCustomBrandingConfig = ():
    | BrandingConfiguration
    | undefined => {
    const settingsElement = document.getElementById(ConfigElements.SETTINGS);
    if (settingsElement) {
        const settings = JSON.parse(
            settingsElement.innerHTML
        ) as PortalSettings;
        return settings?.brandingConfiguration;
    } else {
        return undefined;
    }
};
